import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_3 = {
  class: "row",
  style: {"height":"50px"}
}
const _hoisted_4 = { class: "col no-padding row justify-between items-end q-mb-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = {
  class: "left q-pl-xs text-bold",
  style: {"width":"205px"}
}
const _hoisted_7 = {
  class: "row",
  style: {"height":"50px"}
}
const _hoisted_8 = { class: "col no-padding row justify-between items-center q-mb-lg no-wrap" }
const _hoisted_9 = { class: "text-bold ellipsis" }
const _hoisted_10 = { class: "row no-wrap" }
const _hoisted_11 = { class: "row q-mb-md" }
const _hoisted_12 = { class: "col no-padding" }
const _hoisted_13 = {
  class: "row bg-primary items-center no-padding",
  style: {"padding-right":"3px !important"}
}
const _hoisted_14 = {
  key: 0,
  class: "col no-padding"
}
const _hoisted_15 = {
  key: 1,
  class: "col no-padding"
}
const _hoisted_16 = {
  class: "row left q-mb-md",
  style: {"min-height":"100px"}
}
const _hoisted_17 = {
  key: 0,
  class: "center",
  style: {"width":"100%"}
}
const _hoisted_18 = { class: "q-mr-md" }
const _hoisted_19 = { class: "material-icons" }
const _hoisted_20 = { class: "row justify-end" }
const _hoisted_21 = { class: "text-bold text-grey-6 text-subtitle1 q-px-sm q-mt-xl" }
const _hoisted_22 = {
  class: "row gt-xs",
  style: {"min-height":"100px"}
}
const _hoisted_23 = { class: "col med-possibilities no-padding" }
const _hoisted_24 = { class: "row justify-start" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "q-mr-md" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "material-icons" }, " clear ")
], -1)
const _hoisted_28 = {
  class: "lt-sm q-pa-sm bg-white text-black",
  style: {"position":"fixed","left":"0","bottom":"50px","width":"100%","z-index":"5","box-shadow":"0px -5px 8px rgba(0, 0, 0, 0.05)"}
}
const _hoisted_29 = { class: "row lt-sm q-mt-md" }
const _hoisted_30 = { class: "col q-pa-xs text-grey-6" }
const _hoisted_31 = { class: "row lt-sm" }
const _hoisted_32 = {
  class: "col row med-possibilities no-padding",
  style: {"min-height":"60px","overflow-y":"auto","max-height":"220px"}
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " clear ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "bg-white lt-sm",
  style: {"position":"fixed","left":"0","bottom":"0px","width":"100%","z-index":"4","height":"70px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_CreateRequest = _resolveComponent("CreateRequest")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showRequestForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mutipleHandelsnamesButOneWirkstoffTab, (m, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-sm-1",
              key: idx
            }))
          }), 128)),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Compatibility.DisplayBy')) + ":", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Compatibility.DrugSelection')), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.transport?.name || ''), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(["medOrMolSelected", { medOrMolNotSelected: _ctx.medOrMol === 'mol' }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.medOrMolSwitcher()))
                }, _toDisplayString(_ctx.$t("Compatibility.SelectDrug.TradeNameButton")), 3),
                _createElementVNode("button", {
                  class: _normalizeClass(["medOrMolSelected", { medOrMolNotSelected: _ctx.medOrMol === 'med' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.medOrMolSwitcher()))
                }, _toDisplayString(_ctx.$t("Compatibility.SelectDrug.ActiveIngredientButton")), 3)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ABC, (letter, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "col no-padding gt-sm"
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_q_btn, {
                        class: "col no-padding letter",
                        color: "",
                        "no-caps": "",
                        unelevated: "",
                        round: "",
                        dense: "",
                        onClick: ($event: any) => (_ctx.filter(letter))
                      }, {
                        default: _withCtx(() => [
                          (letter === 'All')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t("Compatibility.SelectDrug.AllButton")), 1))
                            : _createCommentVNode("", true),
                          (letter !== 'All')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(letter), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ABCBySection, (letterSection, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row col no-padding lt-md",
                    style: {"width":"50px","white-space":"nowrap"}
                  }, [
                    (letterSection !== 'All')
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          "no-caps": "",
                          flat: "",
                          color: "primary text-white",
                          label: letterSection
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_menu, {
                              fit: "",
                              anchor: "bottom left",
                              self: "top left"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ExpansionABC(letterSection), (letter, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                                    _createVNode(_component_q_item, {
                                      clickable: "",
                                      onClick: ($event: any) => (_ctx.filter(letter))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(letter), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      : _createCommentVNode("", true),
                    (letterSection === 'All')
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          "no-caps": "",
                          flat: "",
                          color: "primary text-white",
                          label: letterSection,
                          onClick: ($event: any) => (_ctx.filter(letterSection))
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.filteredTab.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "No items matching this filter"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTab, (meds, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "q-pa-xs",
                key: index
              }, [
                _createVNode(_component_q_btn, {
                  onClick: ($event: any) => (_ctx.medOrMol === 'med' ? (_ctx.selected(meds) ? _ctx.removeMedsByMed(meds) : _ctx.addMedsByMed(meds)) : (_ctx.selected(meds) ? _ctx.removeMedsByMol(meds) : _ctx.addMedsByMol(meds))),
                  flat: "",
                  "no-caps": "",
                  class: _normalizeClass(["med-possibility row text-bold q-pr-sm", _ctx.selected(meds) ? 'bg-primary text-white' : 'bg-grey text-grey-8'])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.medOrMol === 'med' ? meds.calculation.medicin.name : meds.calculation.medicin.activeAgent), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selected(meds) ? 'clear' : 'add'), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_q_btn, {
              rounded: "",
              flat: "",
              "no-caps": "",
              "text-color": "white",
              class: "bg-primary text-bold col-xs-12 col-md-6",
              padding: "8px 30px",
              label: _ctx.$t('Compatibility.CompatibilityRequest.NewRequest'),
              onClick: _cache[2] || (_cache[2] = () => { _ctx.toggleRequestForm() })
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('Compatibility.SelectDrug.SelectedMedicinalProducts').toUpperCase()), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.medOrMol === 'mol' ? _ctx.uniqueMol : _ctx.uniqueMed), (meds) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: meds.id
                  }, [
                    _createVNode(_component_q_btn, {
                      "no-caps": "",
                      flat: "",
                      onClick: ($event: any) => (_ctx.medOrMol === 'mol' ? _ctx.removeMedsByMol(meds) : _ctx.removeMedsByMed(meds)),
                      class: "row bg-grey q-ma-sm text-bold text-grey-8 q-pr-sm",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.medOrMol === 'med' ? meds.calculation.medicin.name : meds.calculation.medicin.activeAgent), 1),
                          _hoisted_27
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("footer", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("Compatibility.SelectDrug.SelectedMedicinalProducts")), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.medOrMol === 'mol' ? _ctx.uniqueMol : _ctx.uniqueMed), (meds) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: meds.id
                    }, [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        flat: "",
                        onClick: ($event: any) => (_ctx.medOrMol === 'mol' ? _ctx.removeMedsByMol(meds) : _ctx.removeMedsByMed(meds)),
                        class: "bg-grey q-ma-sm possibility items-center",
                        rounded: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_ctx.medOrMol === 'med' ? meds.calculation.medicin.name : meds.calculation.medicin.activeAgent) + " ", 1),
                            _hoisted_34
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _hoisted_35
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRequestForm)
      ? (_openBlock(), _createBlock(_component_CreateRequest, {
          key: 1,
          transport: _ctx.transport,
          closeForm: _ctx.toggleRequestForm,
          perfusionWay: _ctx.perfusionWay
        }, null, 8, ["transport", "closeForm", "perfusionWay"]))
      : _createCommentVNode("", true)
  ], 64))
}